// extracted by mini-css-extract-plugin
export default {"base":"MapPage_base__4v25B"};